import './Timer.css';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CONSTANTS from './constants';

function Timer({ endTime, gameState, timeLimit, onTimeElapsed, levelID}) { 
    const [secondsLeft, setSecondsLeft] = useState(timeLimit);
    const levelClass = `level-${levelID}`;
    
    useEffect(() => {
        let interval;  // Define the interval variable here.
        if (gameState === CONSTANTS.GAME_STATE_IN_PROGRESS && endTime) {

            interval = setInterval(() => {  // Assign the interval here.
                const now = new Date().getTime();
                const timeDiff = Math.ceil((endTime - now) / 1000);

                if (timeDiff <= 0) {
                    setSecondsLeft(0);
                    onTimeElapsed();
                    clearInterval(interval);
                } else {
                    setSecondsLeft(timeDiff);
                }
            }, 200);
        } else if (gameState === CONSTANTS.GAME_STATE_COMPLETE) {
            setSecondsLeft(0);
            clearInterval(interval);
        }

        // This will clear the interval if the component is unmounted or if isActive changes.
        return () => clearInterval(interval);
    }, [gameState, secondsLeft, onTimeElapsed, endTime]);

    // Don't render timer if timeLimit is null (infinite time)
    if (timeLimit === null || secondsLeft === null || secondsLeft === undefined) {
        return null;
    }

    const minutes = Math.floor(secondsLeft / 60);
    const seconds = secondsLeft % 60;

    return (
        <div className={`timerContainer ${levelClass}`}>
            time: {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        </div>
    );
}

Timer.propTypes = {
    endTime: PropTypes.number,
    gameState: PropTypes.number.isRequired,
    timeLimit: PropTypes.number,
    onTimeElapsed: PropTypes.func.isRequired,
    levelID: PropTypes.string.isRequired
};

export default Timer;